/* assets/ua-shipping.js
  Shopify storefront shipping widget for Nova Poshta and Ukrposhta
  - City/office/street autocompletes
  - Checkout prefill with selected details
  - Ukrposhta via Cloudflare Worker proxy; Nova Poshta via official API
*/
(function () {
  const widget = document.getElementById('ua-ship-widget');
  if (!widget) return;

  const NP_API_KEY    = widget.getAttribute('data-np-key') || '';
  const UP_PROXY_BASE = 'https://cloudflareworkerukrposhtaproxy.tkachuk.workers.dev/api/up';
  // Debug toggles (enable by setting data-up-debug="1" or data-np-debug="1" on #ua-ship-widget)
  const UP_DEBUG = widget.getAttribute('data-up-debug') === '1';
  const NP_DEBUG = widget.getAttribute('data-np-debug') === '1';

  // ---- helpers --------------------------------------------------------------
  async function upProxy(path, params = {}) {
    const qs  = new URLSearchParams(params).toString();
    const url = `${UP_PROXY_BASE}/${path}?${qs}`;
    const res = await fetch(url);
    if (!res.ok) throw new Error('UP proxy failed: ' + res.status);
    return await res.json();
  }
  const arrify = (x) =>
    Array.isArray(x?.Entries?.Entry) ? x.Entries.Entry :
    Array.isArray(x) ? x :
    x?.Entries?.Entry ? [x.Entries.Entry] : [];

  const debounce = (fn, ms = 250) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
  const show = (el, on) => { if (!el) return; el.style.display = on ? 'block' : 'none'; };

  // Coalesce rapid UI updates to avoid flicker (e.g., checkout button enable/disable thrashing)
  let __uaRefreshTimer = null;
  function scheduleRefresh(ms = 120) {
    if (__uaRefreshTimer) clearTimeout(__uaRefreshTimer);
    __uaRefreshTimer = setTimeout(() => {
      __uaRefreshTimer = null;
      try { refreshCheckoutUI(); } catch(_) {}
    }, ms);
  }

  // Mark suggest lists as "interacting" during touch/wheel/scroll so input blur won't close them mid-scroll
  function attachSuggestInteractionGuard(ul){
    if (!ul || ul.__uaGuardAttached) return;
    const mark = () => {
      ul.__uaInteracting = true;
      clearTimeout(ul.__uaInterTimer);
      ul.__uaInterTimer = setTimeout(() => { ul.__uaInteracting = false; }, 350);
    };
    ['pointerdown','touchstart','touchmove','wheel','scroll','mousedown'].forEach(evt => ul.addEventListener(evt, mark, { passive: true }));
    ul.__uaGuardAttached = true;
  }

  // Apply unified dropdown styling and smart placement (up by default, flip down if not enough space)
  function ensureSuggestContainer(ul){
    if (!ul) return;
    const parent = ul.parentElement;
    if (parent && parent.nodeType === 1) {
      const st = window.getComputedStyle(parent);
      if (!st.position || st.position === 'static') parent.style.position = 'relative';
      // allow list to overflow out of the row when opening upward
      if (st.overflow !== 'visible') parent.style.overflow = 'visible';
    }
  }
  function applySuggestBaseStyles(ul){
    if (!ul || ul.__uaStyled) return;
    // ensureSuggestContainer не потрібен для fixed, але залишаємо для сумісності
    ensureSuggestContainer(ul);
    const s = ul.style;
    s.position = 'fixed'; // Змінити з 'absolute' на 'fixed'
    // left та right будуть встановлені в placeSuggestSmart на основі getBoundingClientRect
    s.left = 'auto';
    s.right = 'auto';
    s.bottom = 'auto';
    s.top = 'auto';
    s.zIndex = '10000';
    s.background = '#fff';
    s.boxShadow = '0 6px 18px rgba(0,0,0,0.12)';
    s.maxHeight = 'min(60vh, 320px)';
    s.overflow = 'auto';
    s.webkitOverflowScrolling = 'touch';
    s.overscrollBehavior = 'contain';
    s.touchAction = 'pan-y';
    s.padding = '6px 0';
    s.borderRadius = '6px';
    ul.__uaStyled = true;
  }
  function placeSuggestSmart(ul, anchorInput){
    if (!ul || !anchorInput) return;
    
    // Перевіряємо, чи список порожній - якщо так, ховаємо його
    if (!ul.innerHTML.trim()) {
      ul.style.display = 'none';
      return;
    }
    
    applySuggestBaseStyles(ul);
    
    const rect = anchorInput.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const maxH = (() => {
      // parse maxHeight like 'min(60vh, 320px)' – fallback to 320
      const m = /([0-9]{2,3})px/.exec(ul.style.maxHeight || '');
      return m ? parseInt(m[1], 10) : 320;
    })();
    
    const spaceAbove = Math.max(0, rect.top);
    const spaceBelow = Math.max(0, vh - rect.bottom);
    
    // Встановлюємо left та width на основі позиції input у viewport
    ul.style.left = `${rect.left}px`;
    ul.style.width = `${rect.width}px`;
    ul.style.right = 'auto';
    
    // Визначаємо напрямок (вгору/вниз)
    if (spaceAbove < Math.min(maxH, 200) && spaceBelow > spaceAbove) {
      ul.style.top = `${rect.bottom}px`;
      ul.style.bottom = 'auto';
    } else {
      ul.style.bottom = `${vh - rect.top}px`;
      ul.style.top = 'auto';
    }
    
    // Показуємо список тільки якщо він не порожній
    ul.style.display = 'block';
  }
  function setupSuggest(ul, input){
    if (!ul || !input) return;
    applySuggestBaseStyles(ul);
    attachSuggestInteractionGuard(ul);
    // Recalculate placement when input gets focus or value changes
    const recalc = () => {
      // Перевіряємо, чи список має вміст перед показом
      if (ul.innerHTML.trim()) {
        placeSuggestSmart(ul, input);
      } else {
        ul.style.display = 'none';
      }
    };
    ['focus','input','keydown','keyup'].forEach(evt => input.addEventListener(evt, recalc, { passive: true }));
    // Also adjust on viewport changes when list is visible (важливо для fixed positioning)
    const onViewportChange = () => { 
      // Перевіряємо фактичну видимість через getComputedStyle, а не тільки inline стилі
      // Це важливо, оскільки display може бути встановлений через CSS, а не inline
      const computed = window.getComputedStyle(ul);
      if (computed.display !== 'none' && ul.innerHTML.trim()) {
        recalc(); 
      }
    };
    window.addEventListener('resize', onViewportChange, { passive: true });
    window.addEventListener('scroll', onViewportChange, { passive: true, capture: true });
    // Також оновлюємо при скролі sheet, якщо він є
    const sheet = document.getElementById('ua-sheet');
    if (sheet) {
      sheet.addEventListener('scroll', onViewportChange, { passive: true });
    }
    // Оновлюємо при скролі drawer контейнера (важливо для fixed positioning)
    const drawer = document.getElementById('CartDrawer');
    if (drawer) {
      const drawerContent = drawer.querySelector('.cart-drawer__content');
      if (drawerContent) {
        drawerContent.addEventListener('scroll', onViewportChange, { passive: true });
      }
    }
    // Mark linkage for possible future use
    ul.__uaAnchorInput = input;
  }

  // Safe hook to refresh free-bar (if present)
  const callUpdateBars = (root = document) => { try { window.updateBars && window.updateBars(root); } catch(_){} };

  // Method selectors may be UA/EN; detect by regex
  const isCourier = (val='') => /cour/i.test(val) || /кур'?єр/i.test(val);
  const isBranch  = (val='') => /branch/i.test(val) || /відділ|поштомат/i.test(val);

  // --- ZIP helper (кеш + точний пошук індексу міста через УП: cities -> offices) ---
  const __zipCache = new Map();
  async function fetchZipForCityUA(cityName) {
    const key = (cityName || '').trim().toLowerCase();
    if (!key) return '';
    if (__zipCache.has(key)) return __zipCache.get(key);

    try {
      // 1) знайти місто
      const cities = arrify(await upProxy('cities', { q: cityName }));
      if (!cities.length) { __zipCache.set(key, ''); return ''; }

      // найкраще співпадіння
      const norm = s => String(s || '').trim().toLowerCase();
      const exact = cities.find(c => norm(c.CITY_UA || c.city_ua || c.NAME_UA) === key);
      const starts = cities.find(c => norm(c.CITY_UA || c.city_ua || c.NAME_UA).startsWith(key));
      const pick = exact || starts || cities[0];

      // 2) за CITY_ID тягнемо offices і беремо POSTINDEX
      const cityId =
        pick.CITY_ID || pick.city_id || pick.id || pick.City_ID || pick.CityId || '';
      let zip =
        pick.POSTINDEX || pick.POSTCODE || pick.postindex || pick.postcode || '';

      if (!zip && cityId) {
        const offices = arrify(await upProxy('offices', { city_id: cityId }));
        const withZip = offices.find(o =>
          o.POSTINDEX || o.POSTCODE || o.postindex || o.postcode
        );
        zip = withZip
          ? String(withZip.POSTINDEX || withZip.POSTCODE || withZip.postindex || withZip.postcode || '').trim()
          : '';
      }

      zip = zip || '';
      __zipCache.set(key, zip);
      return zip;
    } catch (_) {
      __zipCache.set(key, '');
      return '';
    }
  }

  // ---- Nova Poshta ZIP helper (uses loaded warehouses when available) ----
  const __zipNPcache = new Map();
  /**
   * Extract postal code from a Nova Poshta warehouse/city object.
   * According to NP API docs:
   * - PostalCodeUA: postal code of the warehouse address
   * - WarehouseIndex: digital address where part before slash is postal code
   * @param {Object} obj
   * @returns {string} postal code or empty string
   */
  function _extractPostalFromNP(obj) {
    if (!obj || typeof obj !== 'object') return '';
    
    // Primary field - PostalCodeUA
    const postalCode = String(obj.PostalCodeUA || '').trim();
    if (postalCode && /^\d{5}$/.test(postalCode)) return postalCode;
    
    // Secondary - try to extract from WarehouseIndex (format: "postal/warehouse")
    const warehouseIndex = String(obj.WarehouseIndex || '').trim();
    if (warehouseIndex) {
      const parts = warehouseIndex.split('/');
      if (parts.length > 0 && /^\d{5}$/.test(parts[0])) {
        return parts[0];
      }
    }
    
    return '';
  }

  /**
   * Obtain a postal code for a Nova Poshta selection.
   * Strategy:
   *  1) Prefer already-loaded warehouses stored on window.__uaNPLastAllWarehouses
   *  2) If not present, call `loadNPWarehouses(cityRef)` to populate data
   *  3) Try exact branchRef match, then any warehouse with a code
   *  4) Fallback to NP getCities call to inspect city-level fields
   * Results are cached in-memory per page load.
   *
   * @param {Object} opts { cityRef, branchRef, cityName }
   * @returns {Promise<string>} postal code or empty string
   */
  async function fetchZipForCityNP({ cityRef, branchRef, cityName } = {}) {
    const cacheKey = String(branchRef || cityRef || cityName || '');
    if (!cacheKey) return '';
    if (__zipNPcache.has(cacheKey)) return __zipNPcache.get(cacheKey);

    try {
      // prefer already-exposed list if present
      let all = Array.isArray(window.__uaNPLastAllWarehouses) ? window.__uaNPLastAllWarehouses.slice() : [];

      // trigger load when we have a cityRef but no cached list
      if ((!all || !all.length) && cityRef) {
        try { await loadNPWarehouses(cityRef); } catch (_) {}
        all = Array.isArray(window.__uaNPLastAllWarehouses) ? window.__uaNPLastAllWarehouses.slice() : [];
      }

      // try exact branch match
      if (branchRef && all && all.length) {
        const found = all.find(w => String(w.Ref || '') === String(branchRef));
        if (found) {
          const code = _extractPostalFromNP(found);
          if (code) { __zipNPcache.set(cacheKey, code); return code; }
        }
      }

      // try any warehouse in the city
      if (all && all.length) {
        for (const w of all) {
          const code = _extractPostalFromNP(w);
          if (code) { __zipNPcache.set(cacheKey, code); return code; }
        }
      }

      // last-resort: query NP getCities for this Ref and inspect returned fields
      if (cityRef && NP_API_KEY) {
        try {
          const payload = { apiKey: NP_API_KEY, modelName: 'Address', calledMethod: 'getCities', methodProperties: { Ref: cityRef } };
          const res = await fetch('https://api.novaposhta.ua/v2.0/json/', {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
          });
          const data = await res.json();
          const list = Array.isArray(data?.data) ? data.data : [];
          for (const it of list) {
            const code = _extractPostalFromNP(it);
            if (code) { __zipNPcache.set(cacheKey, code); return code; }
          }
        } catch (_) {}
      }

      __zipNPcache.set(cacheKey, '');
      return '';
    } catch (err) {
      __zipNPcache.set(cacheKey, '');
      return '';
    }
  }


  
  // ---- DOM ------------------------------------------------------------------
  const cardsWrap = document.getElementById('ua-carrier-cards');
  const cardEls   = cardsWrap ? cardsWrap.querySelectorAll('.ua-card') : [];
  const npRadio   = document.getElementById('ua-carrier-np');
  const upRadio   = document.getElementById('ua-carrier-up');
  const npBlock   = document.getElementById('ua-np');
  const upBlock   = document.getElementById('ua-up');

  // NP
  const npMethod        = document.getElementById('ua-np-method');
  const npCityInput     = document.getElementById('ua-np-city');
  const npCitySuggest   = document.getElementById('ua-np-city-suggest');
  const npCityRef       = document.getElementById('ua-np-city-ref');
  const npCityName      = document.getElementById('ua-np-city-name');
  const npBranch        = document.getElementById('ua-np-branch');
  const npBranchOriginalName = npBranch?.name || '';
  const npSummary       = document.getElementById('ua-np-summary');
  const npBranchWrap    = document.getElementById('ua-np-branch-wrap');
  const npAddressWrap   = document.getElementById('ua-np-address-wrap');
  const npStreetInput   = document.getElementById('ua-np-street');
  const npStreetSuggest = document.getElementById('ua-np-street-suggest');
  // const npStreetRef  = document.getElementById('ua-np-street-ref'); // unused

  // --- Enhance NP branch select with an optional manual input + datalist
  // We create an input + <datalist> for user manual typing. The original
  // <select id="ua-np-branch"> is kept (hidden) and used to store the
  // authoritative Ref when a typed value matches one of the loaded options.
  const npBranchInputEl = (function(){
    if (!npBranch) return null;
    const existing = document.getElementById('ua-np-branch-input');
    if (existing) return existing;
    try {
      const inp = document.createElement('input');
      inp.type = 'text';
      inp.id = 'ua-np-branch-input';
      inp.className = 'ua-input';
      inp.placeholder = 'Оберіть або введіть відділення / поштомат';
      inp.autocomplete = 'off';

  // Створюємо ul для випадаючого списку (як у міста)
  const ul = document.createElement('ul');
  ul.id = 'ua-np-branch-suggest';
  ul.className = 'ua-suggest';
  // Базові стилі та контейнер
  applySuggestBaseStyles(ul);

      // Додаємо input і ul перед select. Ensure parent can be used as positioning context.
      const parent = npBranch.parentNode;
      if (parent && parent.nodeType === 1) {
        const st = window.getComputedStyle(parent);
        if (!st.position || st.position === 'static') {
          parent.style.position = 'relative'; // ensure positioning context for upward list
        }
        if (st.overflow !== 'visible') parent.style.overflow = 'visible';
      }
      parent.insertBefore(inp, npBranch);
      parent.insertBefore(ul, npBranch);
      // if select has a name (for form submission), copy it to input (with suffix)
  // start with input having no name; we'll assign the form name only when user types manually
  inp.name = '';
  // visually hide select but keep for Ref lookups
  npBranch.style.display = 'none';
  npBranch.disabled = false; // keep enabled until user types (we'll toggle)
  // Smart placement wired
  setupSuggest(ul, inp);
      return inp;
    } catch (e) {
      return null;
    }
  })();

  // UP
  const upMethodSelect  = document.getElementById('ua-up-method');
  const upAddressWrap   = document.getElementById('ua-up-address-wrap');
  const upBranchWrap    = document.getElementById('ua-up-branch-wrap');
  const upOfficeInput   = document.querySelector('input[name="attributes[UP Office/Address]"]');
  const upOfficeSuggest = document.getElementById('ua-up-office-suggest');

  const upCityInput   = document.getElementById('ua-up-city');
  const upCitySuggest = document.getElementById('ua-up-city-suggest');
  const upCityRef     = document.getElementById('ua-up-city-ref');   // CITY_ID
  const upCityName    = document.getElementById('ua-up-city-name');

  const upStreetInput   = document.getElementById('ua-up-street');
  const upStreetSuggest = document.getElementById('ua-up-street-suggest');
  const upPostcodeInput = widget.querySelector('input[name="attributes[UP Postcode]"]');

  // --- Checkout buttons: Drawer + Cart Page  (DYNAMIC)
  const applyBtnEl = document.querySelector('#ua-sheet .ua-apply');
  // Ensure Apply button is below suggest dropdowns in stacking order
  try { if (applyBtnEl) applyBtnEl.style.zIndex = '3000'; } catch(_) {}
  const qCheckoutButtons = () =>
    document.querySelectorAll(
      '[data-cart-checkout-button], #checkout, button[name="checkout"], input[name="checkout"]'
    );

  const chosenCarrier = () => (npRadio?.checked ? 'np' : (upRadio?.checked ? 'up' : ''));
  const activeCard = (carrier) => cardEls.forEach(c => c.classList.toggle('active', c.dataset.carrier === carrier));

  function refreshBlocks() {
    const c = chosenCarrier();
    show(npBlock, c==='np'); show(upBlock, c==='up'); scheduleRefresh(0);
    if (c === 'np') applyNpMethod(); else applyUpMethod();
  }

  // картки-перемикачі
  cardEls.forEach(card => {
    card.addEventListener('click', () => {
      const carrier = card.dataset.carrier;
      if (carrier === 'np') npRadio.checked = true; else upRadio.checked = true;
      activeCard(carrier);
      refreshBlocks(); updateSummary(); scheduleRefresh(0);
    });
  });

  // ===== NOVA POSHTА: перемикач способу =====
  function applyNpMethod() {
    if (!npBranchWrap || !npAddressWrap || !npMethod) return;
    const v = npMethod.value || ''; scheduleRefresh(0);
    const courier = isCourier(v);
    show(npAddressWrap, courier);
    show(npBranchWrap, !courier);
  }
  npMethod?.addEventListener('change', () => { applyNpMethod(); updateSummary(); scheduleRefresh(0); });

  // Пошук вулиць НП
  let streetTimerNP = null;
  if (npStreetInput && npStreetSuggest) {
    setupSuggest(npStreetSuggest, npStreetInput);
    npStreetInput.addEventListener('input', function() {
      const cityRef = npCityRef?.value;
      const query = (npStreetInput.value || '').trim();
      
      if (streetTimerNP) clearTimeout(streetTimerNP);
      
      if (!cityRef || !query) {
        npStreetSuggest.style.display = 'none';
        npStreetSuggest.innerHTML = '';
        return;
      }
      
      streetTimerNP = setTimeout(() => searchNPStreets(cityRef, query), 300);
    });

    // Ховаємо підказки при втраті фокусу
    npStreetInput.addEventListener('blur', () => {
      setTimeout(() => {
        if (npStreetSuggest && npStreetSuggest.__uaInteracting) return;
        if (npStreetSuggest) npStreetSuggest.style.display = 'none';
      }, 200);
    });
  }

  async function searchNPStreets(cityRef, query) {
    try {
      if (!NP_API_KEY) return;
      
      const payload = {
        apiKey: NP_API_KEY,
        modelName: "Address",
        calledMethod: "getStreet",
        methodProperties: {
          CityRef: cityRef,
          FindByString: query
        }
      };

      const res = await fetch("https://api.novaposhta.ua/v2.0/json/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      const data = await res.json();
      const streets = data?.data || [];
      
      npStreetSuggest.innerHTML = '';
      
      if (!streets.length) {
        npStreetSuggest.style.display = 'none';
        return;
      }

      streets.forEach(street => {
        const li = document.createElement('li');
        li.textContent = street.Description;
        li.addEventListener('click', () => {
          npStreetInput.value = street.Description;
          npStreetSuggest.style.display = 'none';
          updateSummary();
          scheduleRefresh(0);
        });
        npStreetSuggest.appendChild(li);
      });

      placeSuggestSmart(npStreetSuggest, npStreetInput);
    } catch(e) {
      console.warn('NP streets search error:', e);
      npStreetSuggest.style.display = 'none';
    }
  }

  // NP: city & streets
  let cityTimerNP = null;
  if (npCityInput){
    // Ensure NP city suggest gets unified base styles and smart placement
    if (npCitySuggest) setupSuggest(npCitySuggest, npCityInput);
    npCityInput.addEventListener('input', function(){
      const q = npCityInput.value.trim();
      npCityRef.value = ''; npCityName.value = '';
      npBranch.innerHTML = '<option value="">Оберіть місто спочатку</option>';
      if (npStreetInput) npStreetInput.value = '';
      if (npStreetSuggest) {
        npStreetSuggest.innerHTML = '';
        npStreetSuggest.style.display = 'none';
      }
      if (cityTimerNP) clearTimeout(cityTimerNP);
      if (q.length < 2){ npCitySuggest.style.display='none'; npCitySuggest.innerHTML=''; scheduleRefresh(0); return; }
      cityTimerNP = setTimeout(() => searchNPCities(q), 250);
      scheduleRefresh(0);
    });

    // Hide on blur with interaction guard to prevent closing while scrolling/choosing
    npCityInput.addEventListener('blur', () => {
      setTimeout(() => {
        if (npCitySuggest && npCitySuggest.__uaInteracting) return;
        if (npCitySuggest) npCitySuggest.style.display = 'none';
      }, 180);
    });
  }
  async function searchNPCities(query){
    try{
      if (!NP_API_KEY){ console.warn('NP API key missing'); return; }
      
      // Збираємо всі міста з кількох сторінок для повного результату
      const allCities = [];
      const seen = new Set();
      const PAGE_SIZE = 100; // збільшуємо кількість на сторінці
      let page = 1;
      let hasMore = true;
      let useLimit = true; // спробуємо використати Limit, якщо API підтримує
      
      while (hasMore && page <= 10) { // обмежуємо до 10 сторінок (1000 міст максимум)
        const methodProperties = { 
          FindByString: query, 
          Page: String(page)
        };
        
        // Додаємо Limit, якщо він підтримується
        if (useLimit) {
          methodProperties.Limit = String(PAGE_SIZE);
        }
        
        const payload = { 
          apiKey: NP_API_KEY, 
          modelName:"Address", 
          calledMethod:"getCities", 
          methodProperties
        };
        
        const res = await fetch("https://api.novaposhta.ua/v2.0/json/", { 
          method:"POST", 
          headers:{ "Content-Type":"application/json" }, 
          body: JSON.stringify(payload) 
        });
        
        const data = await res.json(); 
        
        // Перевіряємо наявність помилок у відповіді
        if (data.errors && data.errors.length > 0) {
          if (NP_DEBUG) {
            console.warn('[NP DEBUG] API error on page', page, ':', data.errors);
          }
          // Якщо помилка на першій сторінці з Limit, спробуємо без нього
          if (page === 1 && useLimit) {
            useLimit = false;
            continue; // спробуємо ще раз без Limit
          }
          hasMore = false;
          break;
        }
        
        const batch = data?.data || [];
        
        if (!batch.length) {
          hasMore = false;
          break;
        }
        
        // Додаємо унікальні міста (за Ref)
        for (const city of batch) {
          const key = city.Ref || city.Description;
          if (key && !seen.has(key)) {
            seen.add(key);
            allCities.push(city);
          }
        }
        
        // Якщо отримали менше ніж PAGE_SIZE (або менше ніж стандартний ліміт без Limit), це остання сторінка
        const expectedSize = useLimit ? PAGE_SIZE : 50; // стандартний ліміт API без параметра Limit
        if (batch.length < expectedSize) {
          hasMore = false;
        } else {
          page++;
        }
      }
      
      if (NP_DEBUG) {
        console.info('[NP DEBUG] searchNPCities:', query, 'found', allCities.length, 'cities across', page - 1, 'pages');
      }
      
      // Сортуємо: спочатку точні збіги, потім обласні центри, потім інші
      const queryLower = query.toLowerCase().trim();
      const queryWords = queryLower.split(/\s+/).filter(Boolean);
      
      allCities.sort((a, b) => {
        const aDesc = (a.Description || '').toLowerCase();
        const bDesc = (b.Description || '').toLowerCase();
        
        // 1. Точний збіг назви (місто без дужок і без "обл")
        const aExactMatch = aDesc === queryLower || 
          (aDesc.startsWith(queryLower) && !aDesc.includes('(') && !aDesc.includes('обл'));
        const bExactMatch = bDesc === queryLower || 
          (bDesc.startsWith(queryLower) && !bDesc.includes('(') && !bDesc.includes('обл'));
        if (aExactMatch && !bExactMatch) return -1;
        if (!aExactMatch && bExactMatch) return 1;
        
        // 2. Обласні центри (міста з назвою, що точно збігається з запитом, навіть якщо є "обл")
        const aIsRegionalCenter = aDesc.startsWith(queryLower) && 
          (aDesc.includes('обл') || aDesc === queryLower || aDesc.startsWith(queryLower + ' '));
        const bIsRegionalCenter = bDesc.startsWith(queryLower) && 
          (bDesc.includes('обл') || bDesc === queryLower || bDesc.startsWith(queryLower + ' '));
        if (aIsRegionalCenter && !bIsRegionalCenter) return -1;
        if (!aIsRegionalCenter && bIsRegionalCenter) return 1;
        
        // 3. Міста, що починаються з запиту
        const aStarts = aDesc.startsWith(queryLower);
        const bStarts = bDesc.startsWith(queryLower);
        if (aStarts && !bStarts) return -1;
        if (!aStarts && bStarts) return 1;
        
        // 4. Міста, що містять всі слова запиту
        const aContainsAll = queryWords.every(word => aDesc.includes(word));
        const bContainsAll = queryWords.every(word => bDesc.includes(word));
        if (aContainsAll && !bContainsAll) return -1;
        if (!aContainsAll && bContainsAll) return 1;
        
        // 5. За алфавітом
        return aDesc.localeCompare(bDesc, 'uk');
      });
      
      npCitySuggest.innerHTML=''; 
      if (!allCities.length){ 
        npCitySuggest.style.display='none'; 
        if (NP_DEBUG) console.log('[NP DEBUG] No cities found for query:', query);
        return; 
      }
      
      allCities.forEach(city => {
        const li = document.createElement('li'); 
        li.textContent = city.Description;
        li.addEventListener('click', async () => {
            npCityInput.value = city.Description;
            npCityRef.value = city.Ref;
            npCityName.value = city.Description;
            npCitySuggest.style.display = 'none';

            // Очищаємо поле вулиці при зміні міста
            if (npStreetInput) npStreetInput.value = '';
            if (npStreetSuggest) {
              npStreetSuggest.innerHTML = '';
              npStreetSuggest.style.display = 'none';
            }

            // Завантажуємо відділення і після завантаження фокусуємо інпут відділень
            try {
              await loadNPWarehouses(city.Ref);
              // Якщо існує ручний інпут для відділень — фокусуємо його, щоб показати підказки
              if (typeof npBranchInputEl !== 'undefined' && npBranchInputEl) {
                try {
                  npBranchInputEl.focus();
                  // dispatch focus in case browser doesn't trigger handler synchronously
                  npBranchInputEl.dispatchEvent(new Event('focus'));
                } catch (_) {}
              }
            } catch (err) {
              // ignore loading errors, UI will show fallback state
            }

            updateSummary();
            scheduleRefresh(0);
          });
        npCitySuggest.appendChild(li);
      });
      npCitySuggest.style.display='block';
      placeSuggestSmart(npCitySuggest, npCityInput);
    }catch(e){ console.warn('NP city search error', e); }
  }
  // тягне ВСІ відділення + поштомати НП для міста (поки не закінчаться сторінки)
async function loadNPWarehouses(cityRef) {
  try {
    if (!NP_API_KEY || !cityRef) return;

    npBranch.innerHTML = '<option value="">Завантаження відділень…</option>';

    // Debug flag (set data-np-debug="1" on #ua-ship-widget to enable verbose logs)
    const NP_DEBUG = !!(widget && widget.getAttribute && widget.getAttribute('data-np-debug') === '1');
    if (NP_DEBUG) console.info('[NP DEBUG] loadNPWarehouses start cityRef=', cityRef);

  const PAGE_SIZE = 10000;          // просимо більше (10000) — API може ігнорувати або обмежувати відповіді
    const HARD_ITEM_CAP = 50000;      // техзапобіжник (щоб не повісити UI)
    const seen = new Set();           // уникаємо дублів за Ref
    const all = [];

    let page = 1;
    while (true) {
      const payload = {
        apiKey: NP_API_KEY,
        modelName: "AddressGeneral",
        calledMethod: "getWarehouses",
        methodProperties: {
          CityRef: cityRef,
          Page: String(page),
          Limit: String(PAGE_SIZE),
          Language: "UA"
          // НЕ фільтруємо тип — беремо все (відділення + поштомати)
          // Для суто поштоматів: TypeOfWarehouseRef: "f9316480-5f2d-425d-bc2c-ac7cd29decf0"
        }
      };

      if (NP_DEBUG) console.info(`[NP DEBUG] fetching page ${page} (limit=${PAGE_SIZE})`);
      const res = await fetch("https://api.novaposhta.ua/v2.0/json/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      const data = await res.json();
      const batch = Array.isArray(data?.data) ? data.data : [];
      if (NP_DEBUG) console.info(`[NP DEBUG] page ${page} returned`, Array.isArray(data?.data) ? data.data.length : 0, 'items');
      // keep raw payloads for inspection in console
      try {
        if (NP_DEBUG) {
          window.__uaNPLastResponses = window.__uaNPLastResponses || [];
          window.__uaNPLastResponses.push({ page, raw: data });
        }
      } catch(_) {}

      // додали унікальні записи
      for (const w of batch) {
        const key = w.Ref || `${w.SiteKey || ""}|${w.Description || ""}`;
        if (!seen.has(key)) {
          seen.add(key);
          all.push(w);
          if (all.length >= HARD_ITEM_CAP) break; // safety
        }
      }

      if (NP_DEBUG) console.info(`[NP DEBUG] cumulative unique items after page ${page}:`, all.length);

      // умови виходу: остання сторінка або досягли safety-cap
      if (batch.length < PAGE_SIZE || all.length >= HARD_ITEM_CAP) break;
      page++;
    }

    const isPostomat = (w) =>
      /поштомат/i.test(w.CategoryOfWarehouse || "") ||
      /postomat/i.test(w.CategoryOfWarehouse || "") ||
      /поштомат/i.test(w.Description || "");

    const branches = all.filter(w => !isPostomat(w));
    const lockers  = all.filter(isPostomat);

    branches.sort((a,b) => (parseInt(a.Number||0,10) - parseInt(b.Number||0,10)));
    lockers.sort((a,b) => String(a.Description||"").localeCompare(String(b.Description||"")));

    const list = [...branches, ...lockers];

    if (NP_DEBUG) {
      console.info(`[NP DEBUG] finished loading warehouses for cityRef=${cityRef}`,
        'totalFetched=', all.length,
        'branches=', branches.length,
        'postomats=', lockers.length,
        'finalList=', list.length,
        'HARD_ITEM_CAP_reached=', all.length >= HARD_ITEM_CAP
      );
      try {
        // expose final arrays for debugging
        window.__uaNPLastAllWarehouses = all;
        window.__uaNPLastBranches = branches;
        window.__uaNPLastPostomats = lockers;
        window.__uaNPLastFinalList = list;
      } catch(_) {}
    }

    npBranch.innerHTML = '<option value="">Оберіть відділення</option>';
    for (const w of list) {
      const name = isPostomat(w)
        ? 'Поштомат'
        : (w.Number ? `Відділення №${w.Number}` : 'Відділення');
      const addr = w.ShortAddress || w.Description || '';
      const line = addr ? `${name} — ${addr}` : name;

      const opt = document.createElement('option');
      // value краще зберігати як Ref — унікально і зручно для бекенду
      opt.value = w.Ref || line;
      opt.textContent = line;
      npBranch.appendChild(opt);
    }

    // Наповнюємо випадаючий список для manual input
    try {
      const ul = document.getElementById('ua-np-branch-suggest');
      const inp = document.getElementById('ua-np-branch-input');
      if (ul && inp) {
        ul.innerHTML = '';
        list.forEach(w => {
          const name = isPostomat(w)
            ? 'Поштомат'
            : (w.Number ? `Відділення №${w.Number}` : 'Відділення');
          const addr = w.ShortAddress || w.Description || '';
          const line = addr ? `${name} — ${addr}` : name;

          const li = document.createElement('li');
          li.textContent = line;
          li.addEventListener('click', () => {
            inp.value = line;
            ul.style.display = 'none';
            // Знаходимо відповідний option у select і встановлюємо його
            for (let i = 0; i < npBranch.options.length; i++) {
              if (npBranch.options[i].text === line) {
                npBranch.value = npBranch.options[i].value;
                break;
              }
            }
            updateSummary();
            scheduleRefresh(0);
          });
          ul.appendChild(li);
        });
      }
    } catch (e) {}

    if (list.length === 0) {
      npBranch.innerHTML = '<option value="">Немає доступних відділень</option>';
    }
  } catch (e) {
    console.warn('NP warehouses error', e);
    npBranch.innerHTML = '<option value="">Не вдалося завантажити відділення</option>';
    try { const dl = document.getElementById('ua-np-branch-datalist'); if (dl) dl.innerHTML = ''; } catch(e){}
  }
}



  // ===== UKRPOSHTА: перемикач способу =====
  function applyUpMethod() {
    if (!upMethodSelect || !upAddressWrap || !upBranchWrap) return;
    const v = upMethodSelect.value || ''; scheduleRefresh(0);
    const courier = isCourier(v);
    show(upAddressWrap, courier);
    show(upBranchWrap, !courier);
  }
  upMethodSelect?.addEventListener('change', () => { applyUpMethod(); updateSummary(); scheduleRefresh(0); });

  // --- Пошук населених пунктів УП ---
  const UP_SEARCH_MIN = 3;
  const upCityCache   = new Map();
  const upOfficeCache = new Map();

  let cityTimerUP = null;
  if (upCityInput) {
    setupSuggest(upCitySuggest, upCityInput);
    upCityInput.addEventListener('input', function () {
      const q = upCityInput.value.trim();
      upCityRef.value = ''; upCityName.value = '';
      if (cityTimerUP) clearTimeout(cityTimerUP);
  if (q.length < UP_SEARCH_MIN) { upCitySuggest.style.display='none'; upCitySuggest.innerHTML=''; scheduleRefresh(0); return; }
      cityTimerUP = setTimeout(() => searchUPCities(q), 350);
    });

    // Hide on blur only if the user isn't interacting with the dropdown (prevents closing during scroll)
    upCityInput.addEventListener('blur', () => {
      setTimeout(() => {
        if (upCitySuggest && upCitySuggest.__uaInteracting) return;
        if (upCitySuggest) upCitySuggest.style.display = 'none';
      }, 180);
    });
  }

  async function searchUPCities(query){
    const q = query.trim();
    const key = q.toLowerCase();
    if (upCityCache.has(key)) { renderUpCitySuggest(upCityCache.get(key)); return; }

    try {
      const raw = arrify(await upProxy('cities', { q }));

      const seen = new Set();
      const items = [];
      for (const c of raw) {
        const id  = c.CITY_ID || c.city_id || c.id;
        const nm  = c.CITY_UA || c.city_ua || c.NAME_UA || c.name_ua || '';
        const reg = c.REGION_UA || c.region_ua || c.REGION_EN || '';
        const dst = c.DISTRICT_UA || c.district_ua || c.DISTRICT_EN || '';
        if (!id || !nm) continue;
        if (!nm.toLowerCase().includes(key)) continue;
        const de = `${nm}|${dst}`;
        if (seen.has(de)) continue;
        seen.add(de);
        items.push({ id: String(id), name: nm, region: reg, district: dst });
        if (items.length >= 20) break;
      }

      upCityCache.set(key, items);
      renderUpCitySuggest(items);
    } catch (err) {
      console.error('UP city search error:', err);
      upCitySuggest.style.display='none';
    }
  }

  function renderUpCitySuggest(items){
    upCitySuggest.innerHTML='';
    if (!items || !items.length){ upCitySuggest.style.display='none'; return; }
    items.forEach(it => {
      const label = [it.name, it.district && `р-н ${it.district}`, it.region].filter(Boolean).join(', ');
      const li = document.createElement('li');
      li.textContent = label;
      li.addEventListener('click', async () => {
        upCityInput.value = it.name;
        upCityRef.value   = String(it.id);
        upCityName.value  = it.name;
        upCitySuggest.style.display='none';

        if (upStreetInput && upStreetSuggest) {
          upStreetInput.value = '';
          upStreetSuggest.innerHTML = '';
          upStreetSuggest.style.display = 'none';
        }

        try{
          let offices = upOfficeCache.get(it.id);
          if (!offices){
            const offRes = await upProxy('offices', { city_id: it.id }); // worker aggregates all
            offices = arrify(offRes);
            upOfficeCache.set(it.id, offices);
          }
          if (UP_DEBUG) try { console.info('[UP DEBUG] Prefetch offices for city', it.id, 'count=', Array.isArray(offices)?offices.length:0); } catch(_){ }
          if (offices.length && upPostcodeInput){
            // pick the smallest postal index in the city when available
            const nums = offices.map(o => String(o.POSTINDEX || o.POSTCODE || o.postindex || o.postcode || '').trim()).filter(Boolean);
            let chosen = nums[0] || '';
            try {
              const sorted = nums.slice().sort((a,b)=>parseInt(a,10)-parseInt(b,10));
              chosen = sorted[0] || chosen;
            } catch(_) {}
            if (chosen) upPostcodeInput.value = String(chosen);
          }
        }catch(_){}

        upOfficeInput.value = '';
        upOfficeSuggest.innerHTML=''; upOfficeSuggest.style.display='none';
  updateSummary(); scheduleRefresh(0);
      });
      upCitySuggest.appendChild(li);
    });
    placeSuggestSmart(upCitySuggest, upCityInput);
  }

  // UP offices dropdown block
  if (upOfficeInput) {
    // Функція для показу списку відділень
    const showUpOffices = async (query = '') => {
      const mode = upMethodSelect?.value || '';
      if (!isBranch(mode)) { upOfficeSuggest.style.display='none'; upOfficeSuggest.innerHTML=''; return; }

      const cityId = upCityRef?.value;
      if (!cityId) { upOfficeSuggest.style.display='none'; upOfficeSuggest.innerHTML=''; return; }

      try{
        let list = upOfficeCache.get(cityId);
        if (!list){
          const payload = await upProxy('offices', { city_id: cityId }); // worker aggregates all
          list = arrify(payload);
          upOfficeCache.set(cityId, list);
        }
  if (UP_DEBUG) try { console.info('[UP DEBUG] Show offices for city', cityId, 'fetched=', Array.isArray(list)?list.length:0); } catch(_){ }

        // sort by postal code asc, then by address
        const sortedList = list.slice().sort((a,b)=>{
          const pa = parseInt(String(a.POSTINDEX || a.POSTCODE || a.postindex || a.postcode || '').replace(/\D/g,''),10) || 0;
          const pb = parseInt(String(b.POSTINDEX || b.POSTCODE || b.postindex || b.postcode || '').replace(/\D/g,''),10) || 0;
          if (pa !== pb) return pa - pb;
          const aa = (a.address || a.addressUa || a.Address || a.STREET_UA_VPZ || '').toString();
          const ab = (b.address || b.addressUa || b.Address || b.STREET_UA_VPZ || '').toString();
          return aa.localeCompare(ab);
        });

        upOfficeSuggest.innerHTML='';
        const items = sortedList.map(o => {
          // Prefer postal index (e.g., 79xxx for Lviv) as the visible number
          const postcode = o.POSTINDEX || o.POSTCODE || o.postindex || o.postcode || '';
          const fallbackNum = o.number || o.branchNumber || o.BranchNumber || o.POSTOFFICE_ID || '';
          const displayNum = String(postcode || fallbackNum || '').trim();
          const address = o.address || o.addressUa || o.Address || o.STREET_UA_VPZ || '';
          const name    = displayNum ? `Відділення №${displayNum}` : 'Відділення';
          const label   = address ? `${name} — ${address}` : name;
          const value   = label; // put full label (number + address) into the input, like NP
          return { label, value, postcode };
        }).filter(x => {
          if (!query.trim()) return true; // Показуємо всі, якщо запит порожній
          return x.label.toLowerCase().includes(query.toLowerCase());
        });
  if (UP_DEBUG) try { console.info('[UP DEBUG] Render items count=', items.length, '(sortedList=', sortedList.length, ')'); } catch(_){ }

        if (!items.length){ upOfficeSuggest.style.display='none'; return; }

        items.forEach(it => {
          const li = document.createElement('li');
          li.textContent = it.label;
          li.addEventListener('click', () => {
            upOfficeInput.value = it.value;
            if (it.postcode && upPostcodeInput) upPostcodeInput.value = String(it.postcode);
            upOfficeSuggest.style.display='none';
            updateSummary(); scheduleRefresh(0);
          });
          upOfficeSuggest.appendChild(li);
        });
        placeSuggestSmart(upOfficeSuggest, upOfficeInput);
      }catch(err){
        console.error('UP offices via proxy error:', err);
        upOfficeSuggest.style.display='none';
      }
    };

    // При введенні тексту - фільтруємо
    setupSuggest(upOfficeSuggest, upOfficeInput);
    upOfficeInput.addEventListener('input', debounce(async () => {
      const query = (upOfficeInput.value || '').trim();
      await showUpOffices(query);
    }, 300));

    // При фокусі - показуємо всі відділення
    upOfficeInput.addEventListener('focus', async () => {
      await showUpOffices(); // Показуємо всі без фільтрації
    });

    // Ховаємо при втраті фокусу
    upOfficeInput.addEventListener('blur', () => {
      setTimeout(() => {
        if (upOfficeSuggest && upOfficeSuggest.__uaInteracting) return;
        if (upOfficeSuggest) upOfficeSuggest.style.display = 'none';
      }, 200);
    });
  }

  // Вулиця УП — автопідказка
  if (upStreetInput && upStreetSuggest) {
    setupSuggest(upStreetSuggest, upStreetInput);
    const MIN = 2;
    const debounced = debounce(async () => {
      const cityId = upCityRef?.value;
      const q = (upStreetInput.value || '').trim();
      if (!cityId || q.length < MIN) {
        upStreetSuggest.style.display = 'none';
        upStreetSuggest.innerHTML = '';
        return;
      }
      try {
        const payload = await upProxy('streets', { city_id: cityId, q });
        const list = arrify(payload);

        const seen = new Set();
        const items = [];
        list.forEach(s => {
          const name =
            s.STREET_UA || s.street_ua ||
            s.STREET_UA_VPZ || s.street_ua_vpz ||
            s.Address || s.addressUa || s.address || '';
          if (!name) return;
          const key = name.toLowerCase();
          if (seen.has(key)) return;
          seen.add(key);
          items.push(name);
        });

        upStreetSuggest.innerHTML = '';
        if (!items.length) { upStreetSuggest.style.display = 'none'; return; }

        items.slice(0, 20).forEach(name => {
          const li = document.createElement('li');
          li.textContent = name;
          li.addEventListener('click', () => {
            upStreetInput.value = name;
            upStreetSuggest.style.display = 'none';
            updateSummary(); scheduleRefresh(0);
          });
          upStreetSuggest.appendChild(li);
        });
        placeSuggestSmart(upStreetSuggest, upStreetInput);
      } catch (e) {
        console.error('UP streets via proxy error:', e);
        upStreetSuggest.style.display = 'none';
      }
    }, 300);

    upStreetInput.addEventListener('input', debounced);
    upStreetInput.addEventListener('blur', () => {
      setTimeout(() => {
        if (upStreetSuggest && upStreetSuggest.__uaInteracting) return;
        if (upStreetSuggest) upStreetSuggest.style.display = 'none';
      }, 150);
    });
  }

  // ===== VALIDATION & SUMMARY =====
  function isValidSelection(){
    const npChecked = npRadio && npRadio.checked;
    const upChecked = upRadio && upRadio.checked;
    if (!npChecked && !upChecked) return false;

    if (npChecked){
      const methodV = npMethod?.value || '';
      if (!(npCityRef?.value || (npCityInput?.value || '').trim())) return false;
      // allow manual input value as well
      const selVal = document.getElementById('ua-np-branch')?.value || '';
      const manualVal = (document.getElementById('ua-np-branch-input')?.value || '').trim();
      if (isBranch(methodV) && (!selVal && !manualVal)) return false;
      if (isCourier(methodV)) {
        if (!npStreetInput?.value || !document.getElementById('ua-np-house')?.value) return false;
      }
    }

    if (upChecked){
      const upIndex = (upPostcodeInput?.value || '').trim();
      const upCity  = (upCityInput?.value || '').trim();
      if (!upIndex || !upCity) return false;

      const mode = upMethodSelect?.value || '';
      if (isBranch(mode)) {
        const upOffice = upOfficeInput?.value || '';
        if (!upOffice) return false;
      } else {
        const st = upStreetInput?.value || '';
        const hs = document.getElementById('ua-up-house')?.value || '';
        if (!st || !hs) return false;
      }
    }
    return true;
  }

  function setCheckoutEnabled(enabled){
    qCheckoutButtons().forEach(btn => {
      btn.disabled = !enabled;
      btn.classList.toggle('disabled', !enabled);
      btn.setAttribute('aria-disabled', String(!enabled));
    });
    if (applyBtnEl) applyBtnEl.disabled = !enabled;
  }

  function updateCheckoutState(){ setCheckoutEnabled(isValidSelection()); }

  function updateSummary(){
    const c = chosenCarrier();
    if (c === 'np'){ scheduleRefresh(0);
      const methodVal = npMethod ? (isCourier(npMethod.value) ? 'Кур’єр' : 'Відділення') : '';
      const city = npCityName?.value || npCityInput?.value || '';
      // prefer select Ref->text, but fall back to manual input text
      let branch = '';
      if (isBranch(npMethod?.value||'')) {
        const sel = document.getElementById('ua-np-branch');
        const manual = (document.getElementById('ua-np-branch-input')?.value || '').trim();
        branch = sel?.value ? (sel.options[sel.selectedIndex]?.text || sel.value) : manual;
      }
      if (npSummary) npSummary.value = `Нова пошта — ${methodVal}${city ? ', ' + city : ''}${branch ? ', ' + branch : ''}`;
    } else if (c === 'up'){
      const index = upPostcodeInput?.value || '';
      const city  = upCityInput?.value || '';
      const mode  = upMethodSelect?.value || '';
      let details = '';
      if (isBranch(mode)) {
        details = upOfficeInput?.value || '';
      } else {
        const st = upStreetInput?.value || '';
        const hs = document.getElementById('ua-up-house')?.value || '';
        const ap = document.getElementById('ua-up-apartment')?.value || '';
        details = [st, hs, ap && `кв. ${ap}`].filter(Boolean).join(', ');
      }
      if (npSummary) npSummary.value = `Укрпошта — ${index}${city ? ', ' + city : ''}${details ? ', ' + details : ''}`;
    }
  }

  // Підтримуємо оновлення summary на будь-яку зміну
  ['change','input'].forEach(evt => {
    document.getElementById('ua-np-branch')?.addEventListener(evt, updateSummary);
    npCityInput?.addEventListener(evt, updateSummary);
    widget.querySelectorAll('#ua-up input, #ua-up select').forEach(i => i.addEventListener(evt, updateSummary));
  });

    // If manual branch input exists, wire it up
    if (npBranchInputEl) {
  const branchSuggest = document.getElementById('ua-np-branch-suggest');
  attachSuggestInteractionGuard(branchSuggest);
      
      const filterAndShowSuggestions = (showAll = false) => {
        const text = (npBranchInputEl.value || '').trim().toLowerCase();
        const sel = document.getElementById('ua-np-branch');
        if (!sel) return;

        if (!text && !showAll) {
          sel.value = '';
          if (branchSuggest) branchSuggest.style.display = 'none';
          updateSummary();
          refreshCheckoutUI();
          return;
        }

        // Фільтруємо і показуємо варіанти
        if (branchSuggest) {
          // При фокусі показуємо всі, при введенні фільтруємо
          const items = Array.from(sel.options)
            .slice(1) // Пропускаємо перший option (placeholder)
            .filter(opt => {
              if (showAll) return true; // показуємо всі при фокусі
              return text ? opt.text.toLowerCase().includes(text) : false; // фільтруємо по тексту при введенні
            });

          branchSuggest.innerHTML = '';
          items.forEach(opt => {
            const li = document.createElement('li');
            li.textContent = opt.text;
            li.addEventListener('click', () => {
              npBranchInputEl.value = opt.text;
              sel.value = opt.value;
              branchSuggest.style.display = 'none';
              
              // Встановлюємо правильні імена полів
              sel.disabled = false;
              if (npBranchOriginalName) {
                sel.name = npBranchOriginalName;
                npBranchInputEl.name = npBranchOriginalName + '_manual';
              }
              
              updateSummary();
              scheduleRefresh(0);
            });
            branchSuggest.appendChild(li);
          });
          
          if (items.length > 0) {
            branchSuggest.style.display = 'block';
          } else {
            branchSuggest.style.display = 'none';
            // Це ручний ввід - відключаємо select
            sel.value = '';
            sel.disabled = true;
            if (npBranchOriginalName) {
              sel.name = '';
              npBranchInputEl.name = npBranchOriginalName;
            }
          }
        }
  updateSummary();
  scheduleRefresh(0);
      };

      // Обробка введення
      npBranchInputEl.addEventListener('input', () => {
        filterAndShowSuggestions(false); // false = фільтрувати за введеним текстом
      });
      
      // Ховаємо список при втраті фокусу (з затримкою щоб встиг спрацювати клік)
      npBranchInputEl.addEventListener('blur', () => {
        setTimeout(() => {
          if (branchSuggest && branchSuggest.__uaInteracting) return;
          if (branchSuggest) branchSuggest.style.display = 'none';
          // Перевіряємо чи є точний збіг після закриття списку
          const text = (npBranchInputEl.value || '').trim();
          const sel = document.getElementById('ua-np-branch');
          if (sel) {
            const exactMatch = Array.from(sel.options).find(opt => opt.text === text);
            if (exactMatch) {
              sel.value = exactMatch.value;
              sel.disabled = false;
              if (npBranchOriginalName) {
                sel.name = npBranchOriginalName;
                npBranchInputEl.name = npBranchOriginalName + '_manual';
              }
            } else {
              sel.value = '';
              sel.disabled = true;
              if (npBranchOriginalName) {
                sel.name = '';
                npBranchInputEl.name = npBranchOriginalName;
              }
            }
          }
          updateSummary();
          refreshCheckoutUI();
        }, 200);
      });

      // Показуємо всі варіанти при фокусі
      npBranchInputEl.addEventListener('focus', () => {
        filterAndShowSuggestions(true); // true = показати всі варіанти
      });
    }  // === PREFILL ДО CHECKOUT =====================================
  function getShippingPrefill() {
    const isNP = npRadio?.checked;
    const isUP = upRadio?.checked;

    const npM = npMethod?.value || '';
    const npCity = npCityInput?.value || '';
    const npBr   = npBranch?.value || '';
    const npSt   = npStreetInput?.value || '';
    const npHs   = document.getElementById('ua-np-house')?.value || '';
    const npApt  = document.getElementById('ua-np-apartment')?.value || '';

    const upM  = upMethodSelect?.value || '';
    const upCity = upCityInput?.value || '';
    const upIdx  = (upPostcodeInput?.value || '').trim();
    const upOff  = upOfficeInput?.value || '';
    const upSt   = upStreetInput?.value || '';
    const upHs   = document.getElementById('ua-up-house')?.value || '';
    const upApt  = document.getElementById('ua-up-apartment')?.value || '';

    let address1 = '', address2 = '', city = '', zip = '';

    if (isNP) {
      const courier = isCourier(npM);
      if (courier) {
        address1 = [npSt, npHs].filter(Boolean).join(' ').trim();
        address2 = npApt ? `кв. ${npApt}` : '';
        city = npCity; zip = '';
      } else {
        // prefer select Ref text (if available) else manual input
        const sel = document.getElementById('ua-np-branch');
        const manual = (document.getElementById('ua-np-branch-input')?.value || '').trim();
        const branchText = sel?.value ? (sel.options[sel.selectedIndex]?.text || sel.value) : manual;
        address1 = ['Нова пошта', branchText].filter(Boolean).join(' — ');
        city = npCity; zip = '';
      }
    } else if (isUP) {
      const courier = isCourier(upM);
      if (courier) {
        address1 = [upSt, upHs].filter(Boolean).join(' ').trim();
        address2 = upApt ? `кв. ${upApt}` : '';
        city = upCity; zip = upIdx;
      } else {
        address1 = ['Укрпошта', upOff].filter(Boolean).join(' — ');
        city = upCity; zip = upIdx;
      }
    }
    return { address1, address2, city, zip };
  }

  // ASYNC: якщо НП і zip порожній — підтягнемо за містом (cities -> offices)
  async function buildPrefilledCheckoutUrl() {
    const { address1, address2, city, zip: zipRaw } = getShippingPrefill();
    let zip = (zipRaw || '').trim();

    // Postal code lookup strategy:
    // 1. For Nova Poshta: Try branch first, then city, then fallback to Ukrposhta lookup
    // 2. For Ukrposhta: Use provided zip or try city lookup
    if (!zip) {
      if (npRadio?.checked && city) {
        try {
          // First try with specific branch if selected
          const cityRef = npCityRef?.value || '';
          const branchRef = (document.getElementById('ua-np-branch')?.value || '').trim();
          
          if (branchRef) {
            // Try branch-specific postal code first
            const branchZip = await fetchZipForCityNP({ cityRef, branchRef });
            if (branchZip) {
              zip = branchZip;
            }
          }
          
          // If no branch-specific code, try city lookup in Nova Poshta
          if (!zip && cityRef) {
            const cityZip = await fetchZipForCityNP({ cityRef, cityName: city });
            if (cityZip) {
              zip = cityZip;
            }
          }
          
          // Last resort: try Ukrposhta city lookup
          if (!zip) {
            try { zip = await fetchZipForCityUA(city); } catch(_) {}
          }
        } catch (e) {
          console.warn('Error fetching NP postal code, trying UP lookup:', e);
          try { zip = await fetchZipForCityUA(city); } catch(_) {}
        }
      } else if (city) {
        // For other carriers (like Ukrposhta), try city lookup if we don't have a zip
        try { zip = await fetchZipForCityUA(city); } catch(_) {}
      }
    }

    const params = new URLSearchParams();
    if (address1) params.set('checkout[shipping_address][address1]', address1);
    if (address2) params.set('checkout[shipping_address][address2]', address2);
    if (city)     params.set('checkout[shipping_address][city]', city);
    if (zip)      params.set('checkout[shipping_address][zip]', zip);

    const existing = window.location.search.replace(/^\?/, '');
    if (existing) {
      const ex = new URLSearchParams(existing);
      ex.forEach((v,k) => { if (!params.has(k)) params.set(k,v); });
    }
    return '/checkout?' + params.toString();
  }

  async function saveCartAttributes() {
    const inputs = widget.querySelectorAll('input[name^="attributes["],select[name^="attributes["],textarea[name^="attributes["]');
    const attrs = {};
    inputs.forEach(el => {
      const m = el.name.match(/^attributes\[(.+)\]$/);
      if (m) attrs[m[1]] = (el.value || '').toString();
    });
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      });
    } catch(_) {}
  }

  // ---------- ребінд Checkout ----------
  function rebindCheckoutButtons(){
    const guard = async (e) => {
      if (!isValidSelection()){ e.preventDefault(); e.stopPropagation(); return false; }
      e.preventDefault(); e.stopPropagation();
      try { await saveCartAttributes(); } catch(_) {}
      const url = await buildPrefilledCheckoutUrl();
      window.location.href = url;
      return false;
    };

    qCheckoutButtons().forEach(btn => {
      const ok = isValidSelection();
      btn.disabled = !ok;
      btn.classList.toggle('disabled', !ok);
      btn.setAttribute('aria-disabled', String(!ok));

      if (btn.__uaCheckoutHandler) btn.removeEventListener('click', btn.__uaCheckoutHandler, true);
      btn.__uaCheckoutHandler = guard;
      btn.addEventListener('click', guard, true);
    });

    const form = document.querySelector('form[action="/cart"]') || widget.closest('form');
    if (form) {
      if (form.__uaSubmitHandler) form.removeEventListener('submit', form.__uaSubmitHandler, true);
      form.__uaSubmitHandler = async (e) => {
        if (!isValidSelection()){ e.preventDefault(); e.stopPropagation(); return false; }
        e.preventDefault(); e.stopPropagation();
        try { await saveCartAttributes(); } catch(_) {}
        const url = await buildPrefilledCheckoutUrl();
        window.location.href = url;
        return false;
      };
      form.addEventListener('submit', form.__uaSubmitHandler, true);
    }
  }

  function refreshCheckoutUI(){
    updateSummary();
    updateCheckoutState();
    rebindCheckoutButtons();
    callUpdateBars(document);
  }

  ['input','change','blur'].forEach(evt => {
    widget.querySelectorAll('input, select').forEach(el => {
      el.addEventListener(evt, () => scheduleRefresh(0), { passive:true });
    });
  });

  ['click','change','input'].forEach(evt => {
    document.addEventListener(evt, e => {
      const t = e.target;
      if (!t) return;
      const qtyBtn = t.matches('button[name="plus"], button[name="minus"], .quantity__button');
      const qtyInp = t.matches('input[name^="updates"]');
      const remove = t.matches('[data-remove], .cart-remove, [name="updates[]"]');
      if (qtyBtn || qtyInp || remove) scheduleRefresh(250);
    }, true);
  });

  // Patch global fetch to catch cart changes and refresh the widget
  (function patchFetch(){
    if (window.__uaShipFetchPatched) return;
    window.__uaShipFetchPatched = true;
    const orig = window.fetch;
    window.fetch = async function(...args){
      const res = await orig.apply(this, args);
      try {
        const url = (typeof args[0]==='string') ? args[0] : (args[0]?.url || '');
        if (/\/cart(\/|\.js|\/add|\/change|\/update|\/clear)/.test(url)) scheduleRefresh(300);
      } catch(_) {}
      return res;
    };
  })();

  [
    'form[action="/cart"]',
    '.cart__blocks',
    '#CartDrawerForm',
    '.cart-drawer__body'
  ].forEach(sel => {
    const el = document.querySelector(sel);
    if (!el) return;
    new MutationObserver(() => scheduleRefresh(120)).observe(el, { childList:true, subtree:true });
  });

  // Bottom sheet: reparent to <body> to avoid stacking/context issues and wire open/close
(function(){
  const sheet = document.getElementById('ua-sheet');
  if (!sheet) return;

  const closeBtn      = sheet.querySelector('.ua-sheet__close');
  const applyBtnSheet = sheet.querySelector('.ua-apply');
  const triggersSel   = ['#ua-open-widget', '.ua-open-sheet', '[data-ua-open-widget]'];

  // Place Apply button/possible sticky footer below dropdowns
  try {
    if (applyBtnSheet) {
      applyBtnSheet.style.zIndex = '3000';
      const footer = applyBtnSheet.closest('.ua-sheet__footer, .ua-actions, .ua-footer, .ua-bar, .sheet__footer');
      if (footer) footer.style.zIndex = '3000';
    }
  } catch(_) {}

  // запам'ятовуємо початкове місце й створюємо якір
  const origin = sheet.parentElement;
  const anchor = document.createElement('span');
  anchor.id = 'ua-sheet-anchor';

  const moveToBody = () => {
    if (sheet.parentElement !== document.body) {
      origin?.insertBefore(anchor, origin.firstChild);
      document.body.appendChild(sheet);
    }
  };
  const restoreBack = () => {
    if (anchor.parentNode && origin) {
      origin.insertBefore(sheet, anchor);
      anchor.remove();
    }
  };

  const isDrawerOpen = () => !!document.querySelector('.cart-drawer__body');
  let lastOpenedInDrawer = false;
  const setPageLock = (on) => {
    document.documentElement.classList.toggle('ua-sheet-open', !!on);
    document.body.classList.toggle('ua-sheet-open', !!on);
  };
  const open  = () => {
    moveToBody();
    lastOpenedInDrawer = isDrawerOpen();
    sheet.dataset.context = lastOpenedInDrawer ? 'drawer' : 'page';
    sheet.classList.add('active');
    // Lock page scroll only when opened outside the drawer
    if (!lastOpenedInDrawer) setPageLock(true);
  };
  const close = () => {
    sheet.classList.remove('active');
    setPageLock(false);
    restoreBack();
  };

  triggersSel.forEach(sel =>
    document.querySelectorAll(sel).forEach(btn => btn.addEventListener('click', open))
  );
  closeBtn?.addEventListener('click', close);
  applyBtnSheet?.addEventListener('click', close);

  // Auto-close only if the sheet was opened from the drawer and the drawer disappears
  const mo = new MutationObserver(() => {
    setTimeout(() => {
      if (sheet.classList.contains('active') && sheet.dataset.context === 'drawer' && !isDrawerOpen()) {
        close();
      }
    }, 0);
  });
  mo.observe(document.body, { subtree:true, childList:true, attributes:true, attributeFilter:['class','style','aria-hidden'] });

  // Close on page scroll only for drawer-context sheet; on cart page keep it open
  window.addEventListener('scroll', () => {
    if (sheet.classList.contains('active') && sheet.dataset.context === 'drawer' && !isDrawerOpen()) {
      close();
    }
  }, { passive:true });
})();


  // init
  const setLock = () => {
    const open = !!document.querySelector('.cart-drawer__body');
    document.documentElement.classList.toggle('ua-drawer-open', open);
    document.body.classList.toggle('ua-drawer-open', open);
  };
  new MutationObserver(() => setTimeout(setLock, 0)).observe(document.body, { subtree:true, childList:true, attributes:true, attributeFilter:['class','style','aria-hidden'] });
  setLock();

  // Defensive: block vertical scroll outside the drawer when it's open, allow all scroll inside drawer
  (function(){
    let wheelHandler, touchHandler;
    const isOpen = () => document.documentElement.classList.contains('ua-drawer-open') || !!document.querySelector('.cart-drawer__body');
    const isInsideDrawer = (target) => {
      const root = document.getElementById('CartDrawer');
      return root ? (target === root || (target && root.contains(target))) : false;
    };
    const isWidgetScrollableArea = (target) => {
      const t = target instanceof Element ? target : null;
      if (!t) return false;
      return (
        t.closest('#ua-sheet') ||
        t.closest('.ua-suggest') ||
        t.closest('#ua-ship-widget')
      );
    };
    const onWheel = (e) => {
      if (!isOpen()) return;
      // Allow wheel inside drawer; block outside to prevent page scroll
      // Always allow inside shipping widget scrollable areas (dropdowns/sheet)
      if (!isInsideDrawer(e.target) && !isWidgetScrollableArea(e.target)) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    };
    let lastTouchY = 0;
    const onTouchStart = (e) => { if (e.touches && e.touches[0]) lastTouchY = e.touches[0].clientY; };
    const onTouchMove = (e) => {
      if (!isOpen()) return;
      try {
        // Allow any touch move inside drawer and widget areas; block outside
        if (!isInsideDrawer(e.target) && !isWidgetScrollableArea(e.target)) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      } catch(_) {}
    };
    const attach = () => {
      if (wheelHandler) return; // already attached
      wheelHandler = onWheel; touchHandler = onTouchMove;
      window.addEventListener('wheel', wheelHandler, { passive: false, capture: true });
      window.addEventListener('touchstart', onTouchStart, { passive: true, capture: true });
      window.addEventListener('touchmove', touchHandler, { passive: false, capture: true });
    };
    const detach = () => {
      if (!wheelHandler) return;
      window.removeEventListener('wheel', wheelHandler, { capture: true });
      window.removeEventListener('touchstart', onTouchStart, { capture: true });
      window.removeEventListener('touchmove', touchHandler, { capture: true });
      wheelHandler = null; touchHandler = null;
    };
    const reevaluate = () => { if (isOpen()) attach(); else detach(); };
    // Observe DOM and class changes to toggle listeners
    new MutationObserver(() => setTimeout(reevaluate, 0)).observe(document.body, { subtree:true, childList:true, attributes:true, attributeFilter:['class','style','aria-hidden'] });
    reevaluate();
  })();
  if (npRadio?.checked) activeCard('np');
  if (upRadio?.checked) activeCard('up');
  applyNpMethod();
  applyUpMethod();
  refreshBlocks();
  scheduleRefresh(0);
  callUpdateBars(document);

  // консольний прев’ю
  window.__uaPrefillPreview = async () => {
    const url = await buildPrefilledCheckoutUrl();
    const p = new URL(url, location.origin);
    const out = p.pathname + p.search;
    console.log('[UA prefill URL]', out);
    return out;
  };
})();
